/**
 * Centralized Analytics Helper
 * Phase 10: Usage Intelligence
 */

const TRACKING_SCHEMA_VERSION = '1.0.0';

export const trackEvent = (eventName, data = {}) => {
  const common = {
    schema_version: TRACKING_SCHEMA_VERSION,
    app_id: 'captionscript-v1',
    path: window.location.pathname,
    locale: document.documentElement.lang || 'en',
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    screenSize: `${window.screen.width}x${window.screen.height}`,
  };

  // Try to detect user state from available info
  const userState = {
    is_logged_in: !!localStorage.getItem('clerk-db-session-token'), // Simple hint
    fingerprint: localStorage.getItem('cs_anon_fp') || 'unknown',
  };

  const payload = { ...common, ...userState, ...data };

  if (import.meta.env.DEV) {
    console.log(`[Analytics] ${eventName}`, payload);
  }

  // Google Tag Manager / Global Tag
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, payload);
  }

  // Umami Analytics
  if (window.umami && typeof window.umami.track === 'function') {
    window.umami.track(eventName, payload);
  }
};

/**
 * Specifically for purchase intent signals
 */
export const trackIntent = (item, level, data = {}) => {
  trackEvent('purchase_intent', {
    item, // e.g. 'plus_plan', 'pro_plan', 'refine_feature'
    level, // e.g. 'view', 'interact', 'checkout_click'
    ...data
  });
};

/**
 * Specifically for friction/blocker points
 */
export const trackFriction = (point, reason, data = {}) => {
  trackEvent('user_friction', {
    point, // e.g. 'locked_feature', 'limit_reached', 'abandoned_modal'
    reason, // e.g. 'not_plus', 'quota_exhausted'
    ...data
  });
};
